import { get_axios_instance, get_axios_file_instance, api_variables, errorHandler, } from '@/apis/variables.js';

var axios_instance_get = get_axios_instance(api_variables.SERVICE_GET_PERQUISITES);
var axios_instance_create = get_axios_instance(api_variables.SERVICE_CREATE_PERQUISITES_COMPONENT);
var axios_instance_update = get_axios_instance(api_variables.SERVICE_UPDATE_PERQUISITES_COMPONENT);
var axios_instance_delete = get_axios_instance(api_variables.SERVICE_DELETE_PERQUISITES_COMPONENT);
var axios_instance_download_template_New = get_axios_file_instance(api_variables.SERVICE_MAP_TO_EMPLOYEE_DOWNLOAD_TEMPLATE);
var axios_instance_upload_template = get_axios_instance(api_variables.SERVICE_MAP_TP_EMPLOYEE_UPLOAD_TEMPLATE);

const _pk_name = "id";

const state = {
  data: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false,
  editMode: false,
  record:{}
};

const getters = {
  editMode:(state) =>{
    return state.editMode;
  },
  record: (state) => {
    return state.record;
  }
}

const mutations = {
  set: (state, [payload, le_id]) => {
    if (le_id) {
      state.data[le_id] = payload;
      state.data = { ...state.data };
    }
  },

  addEntity: (state, [payload, id]) => {
    if (!state.data[id]) {
      state.data[id] = [payload];
    } else {
      state.data[id].push(payload);
    }
  },

  updateEntityById: (state, [payload, id]) => {
    for(let i=0; i < state.data[id].length; i++) {
      if(state.data[id][i][_pk_name] === payload.id) {
        state.data[id].splice(i, 1, payload);
      }
    }
  },

  removeEntityById: (state, [payload, id]) => {
    for (let i=0; i < state.data[id].length; i++){
      if (state.data[id][i][_pk_name] == payload){
        state.data[id].splice(i, 1);
      }
    }
    if(state.data[id].length==0)
      state.data={}
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
  setEditMode: (state, payload) => {
    state.editMode = payload.editMode;
    state.record = payload.record;
  }
}

const actions = {
  async fetchPerquisites({commit}, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_get.get(`/`, {
        params: {
            le_id: payload
          }
      });
      commit("setFetching", false);
      if(res.status == 200) {
        if(res.data.payload.perk_list.length!=0)
         commit("set", [res.data.payload.perk_list, payload]);
      }
      return res;
    }catch(error) {
      throw errorHandler(error.response);
    }
  },

//   async uploadTemplate({ commit }, payload) {
//     try {
//       commit("setFetching", true);
//       let res = await axios_instance_upload_template.post(``, payload);
//       commit("setFetching", false);
//       return res;
//     } catch (error) {
//       throw errorHandler(error.response);
//     }
//   },

  async create({commit}, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_create.post('/', payload);
      commit("setSaving", false);
      if(res.status == 200) {
        commit("addEntity", [res.data.payload, payload.le_id]);
      }
      return res;
    }catch(error) {
      throw errorHandler(error.response);
    }
  },

  async update({commit}, [payload, le_id]) {
    try {
      commit("setSaving", true);
      let res = await axios_instance_update.put(`/`, payload );
      commit("setSaving", false);
      if (res.status == 200) {
          commit("updateEntityById", [res.data.payload, le_id]);
      }
      return res;
    } catch(error) {
      throw errorHandler(error.response);
    }
  },

  async delete({commit}, payload) {
    //console.log("[state/onboard/departments/delete] Payload:", payload);
    //console.log("[state/onboard/departments/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance_delete.delete(`/`, payload);
      commit("setDeleting", false);
      // if (res.status == 200){
      //   commit("removeEntityById", [payload.id, payload.le_id]);
      // }
      return res;
    } catch(error) {
      throw errorHandler(error.response);
    }
  },

  async changeEditMode({ commit }, payload) {
    //console.log(
    //   "[state/onboard/departments/changeEditMode] Payload:",
    //   payload
    // );
    try {
      commit("setEditMode", payload);
    } catch(err) {
      //console.log(err)
    }
  },

  async getPerquisiteTemplate({commit},payload) {
    try {
      let res = await axios_instance_download_template_New.get(``, {
        params: payload
      });
      if (res.data.status) {
        const link = document.createElement("a");
        link.href = res.data.payload;
        link.setAttribute("download", "Perquisites Template"+ ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
    }
    } catch (err) {
        throw errorHandler(error);
    }
  },

  async uploadPerquisiteTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (error) {
      throw errorHandler(error.response);
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions,getters
}
